/**
 * The channel the ICS-201 card uses to hear about saves made by components it
 * borrows.
 *
 * Separate from the provider so that the data hooks reading it — objectives,
 * actions, resource sets — pick up nothing but React. Importing the provider
 * instead would pull the form-version mutation stack into every module those
 * hooks touch, which is both wrong-way-round layering and more than the node
 * test suite can resolve.
 *
 * The default is a no-op, so a hook called anywhere other than inside the card
 * records nothing.
 */
import { createContext, useContext } from 'react';

export const RecordIcs201VersionContext = createContext<() => void>(() => {});

export const useRecordIcs201Version = (): (() => void) =>
  useContext(RecordIcs201VersionContext);
